var _ellipse, _circle, _path, _ellipse2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.5,
    cy: 11.5,
    rx: 3.5,
    ry: 3.5,
    fill: "#FFCC00",
    fillOpacity: 0.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0003,
    cy: 12.0003,
    r: 7.97143,
    stroke: "#FFCC00",
    strokeWidth: 0.857143
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2003 8.4L10.2827 8.3245C11.4767 7.23021 13.4015 7.72506 13.9197 9.25951V9.25951V9.25951C14.191 10.2278 13.6717 11.2419 12.7274 11.5878L11.2778 12.1187V13.2",
    stroke: "#FFCC00",
    strokeWidth: 0.857143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.2757,
    cy: 15.4367,
    rx: 0.834903,
    ry: 0.834903,
    fill: "#FFCC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.a12f341794f4ace70f44bf8f9032cd2d.svg";
export { ForwardRef as ReactComponent };